import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

NProgress.configure({
  showSpinner: true,
  trickleSpeed: 100,
  easing: "ease",
  speed: 500,
});

const ProgressBar = () => {
  const location = useLocation();

  useEffect(() => {
    NProgress.start();
    NProgress.done();

    return () => {
      NProgress.done();
    };
  }, [location.pathname]);

  return null;
};

export default ProgressBar;
